export default {
  reg: {
    letter: 'Solo se permiten letras inglesas y espacios'
  }
}